/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".thumb-up-btn[_ngcontent-%COMP%]{color:#4caf50;padding:0}.thumb-up-btn[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{margin-right:5px}.thumb-down-btn[_ngcontent-%COMP%]{color:#f44336;padding:0}.thumb-down-btn[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{margin-left:5px}"];
export { styles as styles };
